export const BREAKPOINTS = {
  sm: '(min-width: 640px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
  xl: '(min-width: 1280px)',
}

export const FILTERS = [
  'categories',
  'styles',
  'media',
  'prices',
  'sizes',
  'orientations',
  'subjects',
]
